import React, {useRef} from 'react'
import { useSmoothScroll } from '../../hooks/useSmoothscroll';
import './accordion.scss';

function ArccordionProvince({data, setAccordionState}) {
    const { scrollTo } = useSmoothScroll();
    const pointScroll = useRef(null);

    const handleScroll = () => {
        const offset = 10; 
            const topPosition =
                pointScroll.current.getBoundingClientRect().bottom +
                window.scrollY +
                offset;

            setTimeout(() => {
                scrollTo(topPosition, 1500); // durée 1,5s, easing par défaut
            }, 200); 
    }

    const handlerShowaccordionPanel = (id, isActive) => {
        //console.log("handlerShowaccordionPanel - id: ", id);
        for (var i in data) {
            if (data[i].id_accord === id) {
                data[i].isActive = !isActive;
            } else
                data[i].isActive = false;
        }
        setAccordionState([...data]);
    }  
    
    const handlerColorMap = (e) => {
        let idColor = parseInt(e)
        //console.log("handlerColorMap - idColor: "+ idColor);
        for (var i in data) {
            if(data[i].id_accord === idColor || idColor === 1) {
                data[i].color = "#e85a4f";
            }  
        }

        for (var j in data) {
            if (!data[j].isActive && idColor !== 1) {
                data[j].color = '#379683';
            }
        }
    }

    const handlerLinks = (item, bond) => {
        for(let k in data) {
            if(data[k].id_accord === item ) {
				for(let l in data) {
					if(data[k].link[l] === bond) {
						data[k].stateLinks[l] = true;
					} else {
						data[k].stateLinks[l] = false;
					}
				}
            }
        }
        setAccordionState([...data]); 
    }

    const Accordion = data.map( accordion => {
        return (
            <div className="accordion" key={accordion.id_accord}>
                <div className={ accordion.isActive ? "accordion-item btn-burger__tranform" : "accordion-item"} style={{backgroundColor: accordion.isActive ? "#e85a4f" : "#379683"}}> 
                    <div className='accordion-item__list'>
                        <div className='list__title'>
                            {accordion.titolo}
                        </div>
                        <div className= "accordion-burger__icon" 
                            onClick={() => {handlerShowaccordionPanel(accordion.id_accord, accordion.isActive); handlerColorMap(accordion.id_accord)}}>
                            <p className="accordion-burger__btn"><span className='accordion-burger__line'></span></p>
                        </div>
                    </div>
                </div>
                <div className={accordion.isActive ? "accordion__panel show-accordion__panel" : "accordion__panel"} >
                    <ul>
                        <li className={accordion.stateLinks[0] ? 'accordion__link actif' : 'accordion__link'} onClick={() => {handlerLinks(accordion.id_accord, accordion.link[0]); handleScroll()}}><span>▶</span> Informazioni generali.</li>
                        <li className={accordion.stateLinks[1] ? 'accordion__link actif' : 'accordion__link'} onClick={() => {handlerLinks(accordion.id_accord, accordion.link[1]); handleScroll()}}><span>▶</span> Terroir e territorio in {accordion.name}.</li>
                        <li className={accordion.stateLinks[2] ? 'accordion__link actif' : 'accordion__link'} onClick={() => {handlerLinks(accordion.id_accord, accordion.link[2]); handleScroll()}}><span>▶</span> Cantine in {accordion.name}.</li>
                        <li className={accordion.stateLinks[3] ? 'accordion__link actif' : 'accordion__link'} onClick={() => {handlerLinks(accordion.id_accord, accordion.link[3]); handleScroll()}}><span>▶</span> Ettari coltivati in {accordion.name}.</li>
                        <li className={accordion.stateLinks[4] ? 'accordion__link actif' : 'accordion__link'} onClick={() => {handlerLinks(accordion.id_accord, accordion.link[4]); handleScroll()}}><span>▶</span> Bottiglie prodotte in {accordion.name}.</li>
                    </ul>
                </div>
            </div>
        )
    })

    return (
        <>
            <div className="container-accordion" ref={pointScroll}>
                {Accordion}
            </div>
        </>
    )
}
export default ArccordionProvince;
